import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Box, Button, useTheme } from '@mui/material';
import React from 'react';

interface PreviewDrawerActionsProps {
  onAction: (type: string) => void;
}

interface ActionButtonConfig {
  label: string;
  type: string;
  icon: React.ReactNode;
}

const ACTION_BUTTONS: ActionButtonConfig[] = [
  { label: 'Add Note', type: 'addNote', icon: <NoteAddOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'Assign', type: 'assign', icon: <PersonAddAltOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'Schedule', type: 'schedule', icon: <CalendarTodayOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'Status', type: 'status', icon: <SwapHorizIcon sx={{ fontSize: 18 }} /> },
];

export const PreviewDrawerActions: React.FC<PreviewDrawerActionsProps> = ({
  onAction,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        px: 2,
        py: 1.5,
        borderTop: `1px solid ${theme.palette.v4.border}`,
        bgcolor: 'v4.tableEven',
      }}
    >
      {ACTION_BUTTONS.map((btn) => (
        <Button
          key={btn.type}
          size="small"
          startIcon={btn.icon}
          onClick={() => onAction(btn.type)}
          aria-label={btn.label}
          sx={{
            textTransform: 'none',
            color: 'text.secondary',
            fontSize: '0.8125rem',
            '&:hover': {
              color: theme.palette.v4.accent,
              bgcolor: 'transparent',
            },
          }}
        >
          {btn.label}
        </Button>
      ))}
    </Box>
  );
};
